document.addEventListener('DOMContentLoaded', () => {
  
    const sliderSwiper = new Swiper('.slider-swiper', {
		slidesPerView: 1,
		loop: true,
		speed: 600,
		navigation: {
			nextEl: ".slider-next",
			prevEl: ".slider-prev",
		},
        fadeEffect: {
			crossFade: true,
		},
		effect: "fade",
	});

	const featuredSliderSwiper = new Swiper('.featured-slider_swiper', {
		slidesPerView: "auto",
		speed: 800,
		spaceBetween: 20,
		loop: true,
		direction: 'horizontal',
		mousewheel: true,
		autoplay: {
			delay: 4000,
			pauseOnMouseEnter: true
		},
		navigation: {
			nextEl: ".specials-home-next",
			prevEl: ".specials-home-prev",
		},
		on: {
			slideChange: function () {
				const currentSlide = this.realIndex + 1;
				document.querySelector("#update-num-specials").innerHTML = currentSlide;
			}
		}
	});

	const specialsSwiper = new Swiper('.specials-swiper', {
		speed: 800,
		spaceBetween: 40,
		loop: true,
		slidesPerView: 2,
		breakpoints: {
			1260: {
				slidesPerView: 3
			}
        },
		navigation: {
			nextEl: ".specials-next",
			prevEl: ".specials-prev",
		}
	});

	//location map pins

	document.querySelectorAll('.location-swiper').forEach(slider => {
		const swiperID = slider.getAttribute("data-id");
		const currentNum = document.getElementById(`update-num-${swiperID}`);
		const wrapper = slider.closest('.location-wrapper');
		const pins = wrapper.querySelectorAll("[data-pin]");

		let swiperOptions = {
			slidesPerView: 1,
			speed: 600,
			fadeEffect: {
				crossFade: true,
			},
			loop: true,
			effect: "fade",
			navigation: {
				nextEl: `.location-next-${swiperID}`,
				prevEl: `.location-prev-${swiperID}`,
			},
			on: {
				slideChange: function () {
					const currentSlide = this.realIndex + 1;
					currentNum.innerHTML = currentSlide;
					pins.forEach(el=>el.classList.remove("active"));
					const activePin = [...pins].find(
						pin => Number(pin.dataset.num) === this.realIndex
					);
					if (activePin) activePin.classList.add("active");
				}
			}
		};

		const locationSwiper = new Swiper(slider, swiperOptions);

		pins.forEach(pin => {
			pin.addEventListener("click", () => {
				const pinNum = Number(pin.dataset.num);
				locationSwiper.slideToLoop(pinNum);
				pins.forEach(el=>el.classList.remove("active"));
				pin.classList.add("active")
			})
		})

	});
});